import { Box, Grid, makeStyles, Tab, Tabs, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  getAllCategoriesAndSubCategories,
  getVendorMenus,
  getVendorProducts,
  getVendorOffers,
  getVendorById,
  getVendorWithSuperCategory,
  getAllSuperCategory,
  pushEvent
} from '../../../store/actions/user/User';
import { saveEventData } from "../../../utils/events-handler"
import Items from './Items';
import ViewMoreItems from './ViewMoreItems';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { scroller } from "react-scroll";
import Footer from '../Footer/Footer';
import LeftTab from './LeftTab'
import Hidden from '@material-ui/core/Hidden';
import Moment from 'moment';
import SearchBar from "material-ui-search-bar";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { handleOpen } from '../../../store/reducers/userReducer';
import ReactPixel from 'react-facebook-pixel';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


const useStyles = makeStyles((theme) => ({
  productMenuListing: {
    paddingTop: '4rem',
    height: 'auto',
    width: '100%',
    background: '#f9f9f8'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  menuContainer: {
    flexGrow: 1,
    paddingLeft: '4rem',
    paddingRight: '4rem',
    display: 'flex',
    marginTop: '1rem',
    [theme.breakpoints.down('sm')]: {
      padding: '0rem 2rem'
    }
  },
  tabContainer: {
    [theme.breakpoints.down('sm')]: {
      marginLeft: '-11%',
      width: '10%'
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: '-3%',
      width: '5%'
    }
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    minWidth: '250px',
    position: '-webkit-sticky',
    position: 'sticky',
    top: 70,
    paddingTop: '40px',
  },
  tabsDiv: {
    borderRight: `1px solid ${theme.palette.divider}`,
    minWidth: '250px',
    position: '-webkit-sticky',
    position: 'sticky',
    top: 70,
  },
  horizontalTabs: {
    width: '100%',
    background: 'white',
    zIndex: 999,
    position: '-webkit-sticky',
    position: 'sticky',
    top: 70,
  },
  tabItem: {
    alignItems: 'flex-start',
    '&:focus': {
      outline: '0px'
    }
  },
  vendorDetail: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    minHeight: '250px',
    paddingTop: '30px',
    backgroundRepeat: 'no-repeat !important',
    backgroundSize: 'cover !important',
    backgroundPosition: 'center !important',
  },
  vendorName: {
    fontSize: '30px',
    fontWeight: 'bold',
    paddingTop: '3%',
    color: 'black'
  },
  vendorImage: {
    width: '380px'
  },
  vendorSubDetail: {
    width: '20%',
    textAlign: 'center',
    backgroundColor: 'rgb(255,255,255, 0.5)',
    borderRadius: '15px',
    marginBottom: '2%',
    [theme.breakpoints.down('sm')]: {
      width: '52%',
    }
  },
  vendorSearch: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '82%',
    }
  },
  distance: {
    color: 'black',
    paddingRight: '5px',
    fontWeight: 'bold'
  },
  vendorLocation: {
    // display: 'flex'
    color: 'black'
  },
  street: {
    fontWeight: 'bold'
  },
  vendorStatus: {
    color: 'green',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  vendorDuration: {
    fontSize: '14px',
    fontWeight: 'bold'
  },
  horiButton: {
    alignItems: 'center !important'
  },
  verButton: {
    alignItems: 'flex-start !important',
    textAlign: 'left'
  },
  tabSelected: {
    outline: 'none !important'
  }
}));

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

function HorizonatalA11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
    style: {
      justifyContent: 'center'
    }
  };
}

const ProductAndMenus = (props) => {
  var closed = false
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [agent, setAgent] = useState('')
  const [todayDay, setTodayDay] = useState('sunday');
  const [subCategoryValue, setSubCategoryValue] = React.useState(0);
  const [vendor, updateVendor] = useState({});
  const [isRestaurant, updateIsRestaurant] = useState(false);
  const [reachedTop, setReachedTop] = React.useState(false);
  const [allProducts, updateProducts] = useState([]);
  const [allOfferProducts, updateOfferProducts] = useState([]);
  const [allMenus, updateMenus] = useState([]);
  const [categories, updateCategories] = useState([]);
  const [searchedText, updateSearchedText] = useState('');
  const [searchedProducts, updateSearchedProducts] = useState(null);
  const [viewMoreSubCategoryId, setViewMoreSubCategoryId] = useState(null);
  const [viewMoreSubCategoryIndex, setViewMoreSubCategoryIndex] = useState(null)
  const [viewMoreIndex, setViewMoreIndex] = useState(null)
  const [viewMoreIsOffer, setViewMoreIsOffer] = useState(false)
  const [viewMoreClosed, setViewMoreClosed] = useState(null)
  const [viewMoreSubCategoryName, setViewMoreSubCategoryName] = useState(null)
  const [openViewMore, setOpenViewMore] = useState(false)
  useEffect(() => {
    const { superCategoryId, vendorId } = props.match.params;
    const payload = {
      superCategoryId: superCategoryId,
      latitude: localStorage.getItem('latitude') || '-33.865143',
      longitude: localStorage.getItem('longitude') || '151.209900'
    };
    updateVendor({});
    props.getVendorById(payload, vendorId);
    props.getAllCategoriesAndSubCategories(superCategoryId, vendorId).then((resp) => {
      updateCategories(resp?.data || []);
    });
    props.getVendorProducts(vendorId).then((resp) => {
      updateProducts(resp?.data || []);
    });
    props.getVendorOffers(vendorId).then((resp) => {
      updateOfferProducts(resp?.data || []);
    })
    // props.getAllSuperCategory().then((resp) => {
    //   if (resp) {
    //     resp.data.map((item) => {
    //       if (item.isResturant) {
    //         props.getVendorMenus(vendorId).then((resp) => {
    //           updateMenus(resp?.data || []);
    //         });
    //       }
    //       if (item.id === superCategoryId) {
    //         updateIsRestaurant(item.isRestaurant);
    //       }
    //     });
    //   }
    // });
    whichDayIsToday();
    if (/iPad/.test(navigator.userAgent)) {
      setAgent('iPad')
    } else if (/Mobi/.test(navigator.userAgent)) {
      setAgent('mobile')
    }
  }, []);

  const whichDayIsToday = () => {
    let d = new Date();
    let weekday = new Array(7);
    weekday[0] = 'sunday';
    weekday[1] = 'monday';
    weekday[2] = 'tuesday';
    weekday[3] = 'wednesday';
    weekday[4] = 'thursday';
    weekday[5] = 'friday';
    weekday[6] = 'saturday';
    setTodayDay(weekday[d.getDay()]);
  };

  useEffect(() => {
    if (props?.vendorById) {
      const { vendorId } = props.match.params;
      // const tempVendor = props?.vendorBySuperCategory?.find(
      //   (item) => item.id === vendorId
      // );
      let eventsApiCall
      if (vendorId === props.vendorById.id) {
        updateVendor(props.vendorById);
        if (props.vendorById.eventTag) {
          const options = {
            autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
            debug: false, // enable logs
          };
          ReactPixel.init('831925394401262', {}, options);
          ReactPixel.trackCustom(props.vendorById.eventTag, { 'url': window.location.href });
          saveEventData(props.pushEvent, props.vendorById.eventTag)
          eventsApiCall = setInterval(() => {
            saveEventData(props.pushEvent, props.vendorById.eventTag)
          }, 120000)
        } else {
          saveEventData(props.pushEvent, "ProductView")
          eventsApiCall = setInterval(() => {
            saveEventData(props.pushEvent, "ProductView")
          }, 120000)
        }
      }
      return () => {
        clearInterval(eventsApiCall);
      };
    }
  }, [props?.vendorById]);

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };



  const handleChange = (event, newValue, mobile) => {
    setSubCategoryValue(0);
    setValue(newValue);
    window.scrollTo(0, 0)
    if (mobile)
      handleDrawerToggle()
  };

  const scrollToSection = (className, index) => {
    const subCategories = categories[value].subCategories
    if (index == subCategories.length - 1)
      scroller.scrollTo(className, {
        duration: 800,
        delay: 0,
        smooth: "easeInOutQuart",
      });
    else {
      var element = document.getElementsByClassName(className)[0];
      element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }

  };



  const handleSubCategoryChange = (event, newValue) => {
    setSubCategoryValue(newValue);
    scrollToSection(`horizontal-tabs-${newValue}`, newValue)
  };

  function checkInViewport() {
    const leftTab = document.getElementById('leftTab')
    if (leftTab) {
      const rectLeftTab = leftTab.getBoundingClientRect();
      if (rectLeftTab.top <= 70) {
        setReachedTop(true)
      } else {
        setReachedTop(false)
      }
    }
    setTimeout(() => {
      const subCategories = categories[value]?.subCategories;
      var max = -1
      for (var i = 0; i < (subCategories ? subCategories.length : 0); i++) {
        const element = document.getElementsByClassName(`horizontal-tabs-${i}`)[0];
        if (element) {
          const rect = element.getBoundingClientRect();
          if (i == 0) {
            if (rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.bottom > (window.innerHeight || document.documentElement.clientHeight)) {
              max = 0
            }
          }
          const available = (
            (rect.top >= 0) &&
            rect.left >= 0 &&
            (rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          )
          if (available) {
            if (max < i) {
              max = i
            }
          }
        }
      }
      if (max == -1) {
        // if(subCategoryValue !== (subCategories ? subCategories.length : 0) - 1 ){
        //   setSubCategoryValue(0);
        // }
      } else {
        setSubCategoryValue(max);
      }
    }, 500)

  }

  const openViewMorePanel = (subCategoryIndex, index, closed, offer, subCategoryId, name) => {
    setViewMoreSubCategoryIndex(subCategoryIndex)
    setViewMoreIndex(index)
    setViewMoreClosed(closed)
    setViewMoreIsOffer(offer)
    setOpenViewMore(true)
    setViewMoreSubCategoryId(subCategoryId)
    setViewMoreSubCategoryName(name)
  }

  const handleSearch = (newValue) => {
    if (newValue.length == 0) {
      updateSearchedProducts(null)
    } else {
      const tempItems = allProducts?.filter((item) => {
        return item?.description?.toLowerCase().indexOf(newValue.toLowerCase()) >= 0 || item?.name?.toLowerCase().indexOf(newValue.toLowerCase()) >= 0;
      });
      updateSearchedProducts(tempItems)
      setValue(0)
    }
  }

  const getOfferCategories = () => {
    var offerCategories = []
    categories.map((category) => {
      const catProduct = allOfferProducts.find((product) => {
        return product.isOffer && product.categoryId === category.id
      })
      if (catProduct && catProduct.categoryId) {
        offerCategories.push(category)
      }
    })
    return offerCategories;
  }

  const getSearchedProductsCategories = () => {
    var offerCategories = []
    categories.map((category) => {
      const catProduct = searchedProducts.find((product) => {
        return product.categoryId === category.id
      })
      if (catProduct && catProduct.categoryId) {
        offerCategories.push(category)
      }
    })
    return offerCategories;
  }

  const handleStatus = (data) => {
    const days = data.days
    const opentime = data.opentime
    const closetime = data.closetime
    closed = !handleOpen(opentime, closetime, days)
    if (!closed) {
      return (<div className={classes.vendorStatus}>{'Open'}</div>)
    } else {
      return (<div className={classes.vendorStatus} style={{ color: 'red' }}>{'Closed'}</div>)
    }
  }

  const findProductSize = (subCategoryId) => {
    const tempItems = allProducts?.filter((item) => {
      return item.subCategoryId === subCategoryId;
    });
    return tempItems.length
  }

  const findOfferProductSize = (subCategoryId) => {
    const tempItems = allProducts?.filter((item) => {
      return item.isOffer && item.categoryId === subCategoryId;
    });
    return tempItems.length
  }

  const findSearchProductSize = (subCategoryId) => {
    const tempItems = allProducts?.filter((item) => {
      return item.categoryId === subCategoryId;
    });
    return tempItems.length
  }

  const handleClose = () => {
    setOpenViewMore(false)
    setViewMoreSubCategoryIndex(null)
    setViewMoreIndex(null)
    setViewMoreClosed(null)
    setOpenViewMore(false)
    setViewMoreSubCategoryId(null)
    setViewMoreSubCategoryName(null)
  }
  window.onscroll = checkInViewport
  return (
    <div style={{
      position: '-webkit-sticky',
      position: 'sticky',
      top: 20,
      bottom: 20
    }}>
      <Dialog
        fullWidth={true}
        maxWidth={'lg'}
        open={openViewMore}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {viewMoreIsOffer ? viewMoreSubCategoryName : categories[viewMoreIndex]?.subCategories[viewMoreSubCategoryIndex].name}
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {viewMoreIsOffer ? <ViewMoreItems
              index={viewMoreSubCategoryIndex}
              isOffer={true}
              categoryId={''}
              subCategoryId={
                viewMoreSubCategoryId
              }
              vendor={vendor}
              closed={viewMoreClosed}
              isRestaurant={isRestaurant}
              vendorId={props?.match?.params?.vendorId}
              allProducts={searchedProducts ? searchedProducts : allProducts}
              allMenus={allMenus}
            />
              : <ViewMoreItems
                index={viewMoreSubCategoryIndex}
                categoryId={categories[viewMoreIndex]?.id}
                subCategoryId={
                  categories[viewMoreIndex]?.subCategories[viewMoreSubCategoryIndex].id
                }
                vendor={vendor}
                closed={viewMoreClosed}
                isRestaurant={isRestaurant}
                vendorId={props?.match?.params?.vendorId}
                allProducts={searchedProducts ? searchedProducts : allProducts}
                allMenus={allMenus}
              />}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          &nbsp;
        </DialogActions>
      </Dialog>

      <div className={classes.productMenuListing} >
        <div className={classes.vendorDetail} style={{
          background: `url(${vendor?.logo})`,
        }}>
          <div className={classes.vendorSubDetail}>
            <div className={classes.vendorName}>{vendor?.name}</div>
            <div className={classes.vendorLocation}>
              <div className={classes.street}>{vendor?.address?.street}</div>
              <div className={classes.distance}>
                {vendor?.distance ? (vendor?.distance / 1000).toFixed(2) + ' KM' : ''}
              </div>
              {vendor?.active && handleStatus({
                days: vendor?.address?.days,
                closetime: vendor?.timing[todayDay]?.closeTime
                ,
                opentime: vendor?.timing[todayDay]?.openTime
              })}
              {vendor?.distanceAndDuration?.duration && (<div className={classes.vendorDuration}><AccessTimeIcon style={{ fontSize: 14 }} /> {vendor?.distanceAndDuration?.duration.text}</div>)}
            </div>
          </div>
          <div className={classes.vendorSearch} style={{ marginTop: '-1.5%' }}>
            <SearchBar
              value={searchedText}
              placeholder={'Search Products'}
              onChange={(newValue) => {
                updateSearchedText(newValue)
                handleSearch(newValue)
              }}
              onCancelSearch={() => {
                updateSearchedText('')
                handleSearch('')
              }}
              onRequestSearch={() => handleSearch(searchedText)}
            />
          </div>
        </div>
        <hr></hr>
        {categories?.length ? (
          <div className={classes.menuContainer} id="leftTab">
            <div className={classes.tabContainer}>
              <div style={{ width: '5%' }}>
                <Hidden lgUp implementation="css" >
                  <LeftTab extraMargin={true} showOffer={!props.productLoading && getOfferCategories().length !== 0} handleDrawerToggle={handleDrawerToggle} mobileOpen={mobileOpen} handleChange={(e, newValue) => handleChange(e, newValue, true)} value={value} categories={categories} a11yProps={a11yProps} />
                </Hidden>
              </div>
              <div className={classes.tabsDiv}>
                <Hidden mdDown implementation="css">
                  <Tabs
                    orientation="vertical"
                    value={value}
                    onChange={handleChange}
                    aria-label="Vertical tabs example"
                    style={{ background: 'white', padding: '10px' }}
                    className={classes.tabs}
                  >
                    {searchedProducts && getSearchedProductsCategories().length !== 0 &&
                      <Tab
                        className={classes.tabItem}
                        classes={{
                          wrapper: classes.verButton,
                        }}
                        label={'Search Result'}
                        {...a11yProps(0)}
                      />
                    }
                    {!props.productLoading && getOfferCategories().length !== 0 &&
                      <Tab
                        className={classes.tabItem}
                        classes={{
                          wrapper: classes.verButton,
                        }}
                        label={'Offers'}
                        {...a11yProps(1)}
                      />
                    }
                    {categories?.map((category, index) => (
                      <Tab
                        className={classes.tabItem}
                        classes={{
                          wrapper: classes.verButton,
                        }}
                        label={category.name}
                        onClick={() => {
                          console.log(category)
                        }}
                        {...a11yProps(index + 2)}
                      />
                    ))}
                  </Tabs>
                </Hidden>
              </div>
            </div>
            {props.productLoading && <div style={{ width: '100%', fontWeight: 'bold' }}>{'Loading Products...'}</div>}


            {!props.productLoading && searchedProducts && searchedProducts.length !== 0 &&
              <TabPanel value={value} index={0} agent={agent}>
                <div style={reachedTop ? { position: 'fixed', top: '70px', width: '69%', zIndex: 9999 } : {}}>
                  <Tabs
                    classes={{
                      centered: true,
                      root: classes.horizontalTabs
                    }}
                    value={subCategoryValue}
                    onChange={handleSubCategoryChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                  >
                    {getSearchedProductsCategories().map((subCategory) => (
                      <Tab
                        label={subCategory?.name}
                        com
                        {...HorizonatalA11yProps(0)}
                        classes={{
                          wrapper: classes.horiButton,
                          selected: classes.tabSelected
                        }}
                      />
                    ))}
                  </Tabs>
                </div>
                {props.productLoading && <div>{'Loading Products...'}</div>}
                {!props.productLoading && searchedProducts && searchedProducts.length !== 0 &&
                  getSearchedProductsCategories().map((subCategory, subCategoryIndex) => (
                    <HorizontalTabPanel
                      value={subCategoryValue}
                      index={subCategoryIndex}
                    >
                      <Grid container>
                        <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                          <div style={{
                            textAlign: 'left',
                            fontSize: '22px',
                            fontWeight: 'bold',
                            marginBottom: '20px'
                          }}>{subCategory.name}</div>
                        </Grid>
                      </Grid>
                      <Items
                        index={subCategoryIndex}
                        isOffer={false}
                        isSearch={true}
                        categoryId={''}
                        subCategoryId={
                          subCategory.id
                        }
                        vendor={vendor}
                        closed={closed}
                        isRestaurant={isRestaurant}
                        vendorId={props?.match?.params?.vendorId}
                        allProducts={searchedProducts}
                        allMenus={allMenus}
                      />
                    </HorizontalTabPanel>
                  ))}
              </TabPanel>
            }


            {!props.productLoading && getOfferCategories().length !== 0 &&
              <TabPanel value={value} index={searchedProducts && searchedProducts.length > 0 ? 1 : 0} agent={agent}>
                <div style={reachedTop ? { position: 'fixed', top: '70px', width: '69%', zIndex: 9999 } : {}}>
                  <Tabs
                    classes={{
                      centered: true,
                      root: classes.horizontalTabs
                    }}
                    value={subCategoryValue}
                    onChange={handleSubCategoryChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                  >
                    {getOfferCategories().map((subCategory) => (
                      <Tab
                        label={subCategory?.name}
                        com
                        {...HorizonatalA11yProps(0)}
                        classes={{
                          wrapper: classes.horiButton,
                          selected: classes.tabSelected
                        }}
                      />
                    ))}
                  </Tabs>
                </div>
                {props.productLoading && <div>{'Loading Products...'}</div>}
                {!props.productLoading && getOfferCategories().length !== 0 &&
                  getOfferCategories().map((subCategory, subCategoryIndex) => (
                    <HorizontalTabPanel
                      value={subCategoryValue}
                      index={subCategoryIndex}
                    >
                      <Grid container>
                        <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                          <div style={{
                            textAlign: 'left',
                            fontSize: '22px',
                            fontWeight: 'bold',
                            marginBottom: '20px'
                          }}>{subCategory.name}</div>
                        </Grid>
                        {
                          findOfferProductSize(subCategory.id) > 4 &&
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <div style={{
                              textAlign: 'right',
                              fontSize: '15px',
                              fontWeight: 'bold',
                              marginBottom: '20px',
                              cursor: 'pointer',
                            }} onClick={() => {
                              openViewMorePanel(subCategoryIndex, subCategoryIndex, closed, true, subCategory.id, subCategory.name)
                            }}>{'View More'}</div>
                          </Grid>
                        }
                      </Grid>
                      <Items
                        index={subCategoryIndex}
                        isOffer={true}
                        categoryId={''}
                        subCategoryId={
                          subCategory.id
                        }
                        vendor={vendor}
                        closed={closed}
                        isRestaurant={isRestaurant}
                        vendorId={props?.match?.params?.vendorId}
                        allProducts={searchedProducts ? searchedProducts : allProducts}
                        allMenus={allMenus}
                      />
                    </HorizontalTabPanel>
                  ))}
              </TabPanel>
            }
            {[...Array(categories?.length).keys()].map((index) => (
              <TabPanel value={value} index={index + (!props.productLoading && getOfferCategories().length === 0 ? 0 : 1) + (searchedProducts && searchedProducts.length > 0 ? 1 : 0)} agent={agent}>
                <div style={reachedTop ? { position: 'fixed', top: '70px', width: '69%', zIndex: 9999 } : {}}>
                  <Tabs
                    classes={{
                      centered: true,
                      root: classes.horizontalTabs
                    }}
                    value={subCategoryValue}
                    onChange={handleSubCategoryChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                  >
                    {categories[index]?.subCategories?.map((subCategory) => (
                      <Tab
                        label={subCategory?.name}
                        com
                        {...HorizonatalA11yProps(0)}
                        classes={{
                          wrapper: classes.horiButton,
                          selected: classes.tabSelected
                        }}
                      />
                    ))}
                  </Tabs>
                </div>
                {[...Array(categories[index]?.subCategories?.length).keys()].map(
                  (subCategoryIndex) => (
                    <HorizontalTabPanel
                      value={subCategoryValue}
                      index={subCategoryIndex}
                    >
                      <Grid container>
                        <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                          <div style={{
                            textAlign: 'left',
                            fontSize: '22px',
                            fontWeight: 'bold',
                            marginBottom: '20px'
                          }}>{categories[index]?.subCategories[subCategoryIndex].name}</div>
                        </Grid>
                        {
                          findProductSize(categories[index]?.subCategories[subCategoryIndex].id) > 4 &&
                          <Grid item xs={6} xl={6} lg={6} md={6} sm={6}>
                            <div style={{
                              textAlign: 'right',
                              fontSize: '15px',
                              fontWeight: 'bold',
                              marginBottom: '20px',
                              cursor: 'pointer',
                            }} onClick={() => {
                              openViewMorePanel(subCategoryIndex, index, closed)
                            }}>{'View More'}</div>
                          </Grid>
                        }
                      </Grid>
                      <Items
                        index={subCategoryIndex}
                        categoryId={categories[index]?.id}
                        subCategoryId={
                          categories[index]?.subCategories[subCategoryIndex].id
                        }
                        vendor={vendor}
                        closed={closed}
                        isRestaurant={isRestaurant}
                        vendorId={props?.match?.params?.vendorId}
                        allProducts={searchedProducts ? searchedProducts : allProducts}
                        allMenus={allMenus}
                      />
                    </HorizontalTabPanel>
                  )
                )}
              </TabPanel>
            ))}
          </div>
        ) : null}
      </div>
      <div id="footer">
        <Footer />
      </div>
    </div >
  );
};

const mapStateToProps = (state) => ({
  allProducts: state.user.products,
  allMenus: state.user.menus,
  categories: state.user.categories,
  vendor: state.shared.vendor,
  vendorBySuperCategory: state.user.vendorBySuperCategory,
  vendorById: state.user.vendorById,
  superCategories: state.user.superCategories,
  productLoading: state.user.productLoading
});

const mapDispatchToProps = (dispatch) => ({
  getAllCategoriesAndSubCategories: (superCategoryid, vendorId) =>
    dispatch(getAllCategoriesAndSubCategories(superCategoryid, vendorId)),
  getVendorProducts: (vendorId) => dispatch(getVendorProducts(vendorId)),
  getVendorOffers: (vendorId) => dispatch(getVendorOffers(vendorId)),
  getVendorById: (superCategory, vendorId) => dispatch(getVendorById(superCategory, vendorId)),
  getVendorMenus: (vendorId) => dispatch(getVendorMenus(vendorId)),
  pushEvent: (details) => dispatch(pushEvent(details)),
  getVendorWithSuperCategory: (superCategory) =>
    dispatch(getVendorWithSuperCategory(superCategory)),
  getAllSuperCategory: () => dispatch(getAllSuperCategory())
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductAndMenus);

const TabPanel = (props) => {
  const { children, value, index, agent, reachedTop, ...other } = props;
  return (
    <div
      role="tabpanel"
      id={`vertical-tabpanel-${index}`}
      hidden={value !== index}
      style={reachedTop ? {
        width: '100%',
        overflow: 'scroll',
        marginLeft: '19%'
      } : {
        width: '100%',
        overflow: 'scroll'
      }}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} style={agent === 'mobile' ? { padding: '5px' } : { paddingTop: '0px' }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const HorizontalTabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      style={{ zIndex: 9999 }}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      className={`horizontal-tabs-${index}`}
      {...other}
    >
      {(
        <Box p={3} css={{ marginTop: '20px', background: 'white' }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};


